import { Controller } from "@hotwired/stimulus"

// Loads the contacts of the selected partner into a dependent <select> and
// toggles its visibility. Replaces the former jQuery + js-routes implementation.
//
//   data-controller="contact-select"
//   data-contact-select-url-value="/admin/partners/PARTNER_ID/list_contacts"
//   data-contact-select-old-id-value="42"
//   targets: partner, contact, wrapper
export default class extends Controller {
  static targets = ["partner", "contact", "wrapper"]
  static values = { url: String, oldId: String }

  connect() {
    this.load()
  }

  async load() {
    const partnerId = this.partnerTarget.value

    this.contactTarget.innerHTML = ""
    this.addOption("", "")

    if (!partnerId) {
      this.wrapperTarget.style.display = "none"
      return
    }

    const response = await fetch(this.urlValue.replace("PARTNER_ID", partnerId), {
      headers: { Accept: "application/json" }
    })

    if (!response.ok) return

    const contacts = await response.json()
    this.wrapperTarget.style.display = "block"

    contacts.forEach((contact) => {
      this.addOption(contact.id, `${contact.first_name} ${contact.last_name}`)
    })

    if (this.oldIdValue) {
      this.contactTarget.value = this.oldIdValue
    }
  }

  addOption(value, text) {
    const option = document.createElement("option")
    option.value = value
    option.textContent = text
    this.contactTarget.appendChild(option)
  }
}
